"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetPasswordChangeScreen = void 0;
const radio_dispatch_1 = require("@clearsummit/radio-dispatch");
const react_1 = __importDefault(require("react"));
const react_div_100vh_1 = __importDefault(require("react-div-100vh"));
const react_redux_1 = require("react-redux");
const components_1 = require("@/components");
const constants_1 = __importStar(require("@/constants"));
const forms_1 = require("@/forms");
const services_1 = require("@/helpers/services");
const redux_1 = require("@/redux");
const api_payloads_1 = require("@/redux/api-payloads");
const selectors_1 = __importDefault(require("@/selectors"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
class ResetPasswordChangeScreen extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.state = {
            pending: false
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const { pending, error } = nextProps;
        if (prevState.pending && !pending && !error) {
            return { pending };
        }
        return Object.assign(Object.assign({}, prevState), { pending });
    }
    render() {
        return (react_1.default.createElement(react_div_100vh_1.default, { className: styles_scss_1.default.container },
            react_1.default.createElement(components_1.Meta, { title: constants_1.default.resetPassword.helmetTitle }),
            react_1.default.createElement("div", { className: styles_scss_1.default.leftContainer },
                react_1.default.createElement("img", { className: styles_scss_1.default.backgroundImage, src: constants_1.Images.loginBackground, alt: constants_1.Images.loginBackground }),
                react_1.default.createElement("div", { className: styles_scss_1.default.leftContainerContent },
                    react_1.default.createElement("div", { className: styles_scss_1.default.formContainer },
                        react_1.default.createElement("img", { className: styles_scss_1.default.logo, src: constants_1.Images.logo, alt: "logo" }),
                        react_1.default.createElement("h3", null, constants_1.default.resetPassword.title),
                        react_1.default.createElement("div", { className: styles_scss_1.default.description }, constants_1.default.resetPassword.pleaseEnterYourNewPassword),
                        react_1.default.createElement(forms_1.ResetPasswordChangeForm, null)))),
            react_1.default.createElement("div", { className: styles_scss_1.default.rightContainer },
                react_1.default.createElement("img", { src: constants_1.Images.loginBackground, alt: constants_1.Images.loginBackground }))));
    }
}
exports.ResetPasswordChangeScreen = ResetPasswordChangeScreen;
const mapStateToProps = (state) => ({
    user: selectors_1.default.user.getUser(state),
    pending: radio_dispatch_1.selectors.getPending(state, services_1.endpoints.postResetPassword),
    error: radio_dispatch_1.selectors.getError(state, services_1.endpoints.postResetPassword),
});
const mapDispatchToProps = {
    makeRequest: (data) => redux_1.ActionCreators.api.makeRequest.dispatch(api_payloads_1.resetPasswordChangePayload(data)),
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(ResetPasswordChangeScreen);
